import React, { useState } from 'react';
import Modal from '../../components/Modal/Modal';
import Input from '../../components/Inputs/Input/Input';
import Button from '../../components/Button/Button';
import createModel from '../../api/cars/createModel';
import alert from '../../helpers/alert';

// Компактная модалка добавления модели прямо из формы правки строки стока —
// чтобы не заставлять пользователя идти на отдельную страницу /cars/models и
// возвращаться, если модель из файла просто отсутствует в справочнике
const AddModelModal = ({ isOpen, onClose, markId, markLabel, initialName, onCreated }) => {
  const [name, setName] = useState(initialName || '');
  const [saving, setSaving] = useState(false);

  const handleSave = async () => {
    if (!markId) {
      alert.error('Сначала выберите марку');
      return;
    }
    const trimmed = name.trim();
    if (!trimmed) {
      alert.error('Введите название модели');
      return;
    }
    setSaving(true);
    try {
      // Контроллер (CarsController.createModel) на успехе отдаёт { markId }, а не
      // { code, result } — на ошибке (модель уже существует и т.п.) это 400 с
      // { errorMessage }, который axios прокидывает как исключение
      const response = await createModel({ markId, name: trimmed });
      const newModelId = Number(response?.data?.markId);
      if (!newModelId) {
        alert.error('Не удалось добавить модель');
        return;
      }
      alert.success('Модель добавлена');
      onCreated({ value: newModelId, label: trimmed });
      onClose();
    } catch (err) {
      alert.error(err?.response?.data?.errorMessage || 'Ошибка при добавлении модели');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      title="Добавить модель"
      width="480px"
      contentStyle={{ top: '18%', bottom: 'auto' }}
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
        {markLabel && (
          <div style={{ fontFamily: "'Exo 2', sans-serif", fontSize: 13, color: '#8a8272' }}>
            Марка: <strong>{markLabel}</strong>
          </div>
        )}
        <Input
          label="Название модели"
          placeholder="Например, Soluto"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
        />
        <Button text="Добавить" fill onClick={handleSave} disabled={saving} />
      </div>
    </Modal>
  );
};

export default AddModelModal;
